// const { openDemo, modal: navatticModal } = Navattic({
//   demoUrl: moduleData?.navatticUrl || '',
//   title: moduleData?.navatticTitle || '',
//   moduleSlug: moduleData?.slug || '',
// })
import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { EyeVisible } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface NavatticProps {
  image?: string
  onClick?: () => void
}

const Navattic: React.FC<NavatticProps> = ({ image, onClick }) => {
  return (
    <>
      <Box flexDirection="column" gap="s8">
        <Text size="200" weight="medium">
          <span className="text-f1-foreground-secondary">
            {i18n.t('marketplace.revamp.see_it_in_action')}
          </span>
        </Text>
        <Box flexDirection="column" gap="s8">
          <Box
            style={{
              position: 'relative',
              display: 'inline-block',
              border: '2px solid rgba(5, 38, 87, 0.06)',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            {image?.includes('.mp4') ? (
              <video
                src={image}
                autoPlay
                muted
                loop
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  objectFit: 'cover',
                  filter: 'blur(6px)',
                }}
              />
            ) : (
              <img
                src={image}
                alt="Navattic"
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  objectFit: 'cover',
                  filter: 'blur(6px)',
                }}
              />
            )}
            <Box
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: '10',
              }}
            >
              <F0Button
                variant="outline"
                size="md"
                onClick={onClick}
                icon={EyeVisible}
                label={i18n.t('marketplace.revamp.view_demo')}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Navattic
